import m from 'mithril'
import BaseModel from './_base'
import moment from 'moment'

let _data = []

const constraints = {

}

export default class Guide extends BaseModel {
    constructor(args) {
        super(constraints)
        args = (args) ? args : {};
        this.id = args.id || 0;
        this.name = args.name || "";
        this.content = args.content || "";
        this.isUrl = args.isUrl || false;
    }

    static get data() {
        return _data;
    }

    static fetch(type) {
        Guide.loading = true
        let url = `${window.BASE_URL}/api/setting/guide/${type}`
        return m.request({
            method: 'POST',
            url: url,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
        }).then((response) => {
            _data = response
            Guide.loading = false
            return response
        })
    }

    static save(data) {
        return m.request({
            method: 'POST',
            url: `${window.BASE_URL}/api/setting/guide`,
            data: data,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
        })
    }

    static load(type) {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/api/setting/guide/detail/${type}`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
        }).then((response) => {
            return response
        })
    }

    static delete(id) {
        return m.request({
            method: 'DELETE',
            url: `${window.BASE_URL}/api/setting/guide/${id}`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
        })
    }
}